export class ApiResponseDTO {

    statusCode: number;
    
    message: string;

    messageType: number;

}
